import useProjects from '@activities/ProjectActivity/hooks/useProjects';
import Card from '@components/Card';
import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import Header from '@components/Header';
import Radio from '@components/Radio';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useToast from '@hooks/ui/useToast';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        ProjectActivity: {};
    }
}

const ProjectActivity: ActivityComponentType<'ProjectActivity'> = () => {
    const [cookies, setCookies] = useCookies(['projectId', 'lang']);
    const defaultProjectId = cookies.projectId;
    const toast = useToast();
    const projects = useProjects();
    const handleSave = (projectId: string) => {
        setCookies('projectId', projectId, { path: '/', maxAge: 60 * 60 * 24 * 365 * 20 });
        toast.success('프로젝트 ID가 저장되었습니다.');
        window.location.href = '/';
    };
    const { i18n } = useTranslation();
    const { language, changeLanguage } = i18n;
    const updateLanguage = (lang: string) => {
        setCookies('lang', lang, { path: '/', maxAge: 60 * 60 * 24 * 365 * 20 });
        changeLanguage(lang);
    };
    return (
        <AppScreen>
            <Column fullWidth>
                <Header title='테스트 설정' />
                <Container
                    spacing={16}
                    fullWidth >
                    <Text fontWeight='bold'> 프로젝트 선택 </Text>
                    <Column fullWidth spacing={8}>
                        {projects?.map((project) => (
                            <Card key={project.id}
                                onClick={() => handleSave(project.id)} >
                                <Card.Body>
                                    <Row fullWidth justify='space-between'>
                                        <Text size='lg' fontWeight='medium'>
                                            {project.name} ({project.id})
                                        </Text>
                                        {defaultProjectId === project.id && (
                                            <Text color={colors.primary} fontWeight='bold'>
                                                선택됨
                                            </Text>
                                        )}
                                    </Row>
                                </Card.Body>
                            </Card>
                        ))}
                    </Column>
                    <Column fullWidth spacing={16}>
                        <Text fontWeight='bold'>언어 설정 </Text>
                        <Radio value='ko' isSelected={language === 'ko'}
                            onChange={() => updateLanguage('ko')}>
                            한국어
                        </Radio>
                        <Radio value='ja' isSelected={language === 'ja'}
                            onChange={() => updateLanguage('ja')}>
                            일본어
                        </Radio>
                        <Radio value='en' isSelected={language === 'en'}
                            onChange={() => updateLanguage('en')} >
                            영어
                        </Radio>
                    </Column>
                </Container>
            </Column>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding: 20px;
`;

export default ProjectActivity;
